/**
 * Implement pause button listeners for Vimeo videos.
 */
(() => {
    if (typeof Vimeo === 'undefined') {
        return;
    }

    document
        .querySelectorAll('.js-pause-button, .js-pause-button-overlay')
        .forEach((el) => {
            const iframe = el
                .closest('.js-vimeo-video')
                ?.querySelector('iframe');

            if (!iframe) {
                return;
            }

            let player = new Vimeo.Player(iframe);

            el.addEventListener('click', (e) => {
                // console.log('Pause button clicked (for a Vimeo video)');

                player.getPaused().then((paused) => {
                    H_Tools.pause.state(e.target, paused); // do this before we play or pause the video

                    if (paused) {
                        player.play();
                    } else {
                        player.pause();
                    }
                });
            });
        });
})();
